import { render, staticRenderFns } from "./storeNotSelfGoods.vue?vue&type=template&id=a2dcc4fe&"
import script from "./storeNotSelfGoods.vue?vue&type=script&lang=js&"
export * from "./storeNotSelfGoods.vue?vue&type=script&lang=js&"
import style0 from "./storeNotSelfGoods.vue?vue&type=style&index=0&id=a2dcc4fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports